module.exports = __webpack_public_path__ + "img/googleplay-download.aa831bd8.png";